import { createFileRoute } from '@tanstack/react-router';

import { CalendarView } from '@/modules/orders/views/CalendarView';

export const Route = createFileRoute('/_app/calendar')({
   component: CalendarView
});
